import { AlertsInfoSections } from "./AlertsInfoSections";
import { HeaderTemplate } from "Components/templates/Header";
import { FooterTemplate } from "Components/templates/FooterTemplate";
import { ToastFeedback } from "Components/atoms/ToastFeedback";
import { AlertForm } from "Components/organisms/AlertForm";
import { GlobalStyles } from "styles/globalStyles";
import { theme } from "styles/theme";
import { ThemeProvider } from "styled-components";
import { Page, HeaderArea } from "pages/Alerts/styles";
import { AlertFormHero } from "./AlertFormHero";
import {
  HowItWorks,
  HowTitle,
  StepItem,
  StepNumber,
  StepsGrid,
  StepText,
  StepTitle,
} from "./marketing.styles";
import { ALERTS_LIST_PATH, useCreateAlert } from "./useCreateAlert";

const STEPS = [
  {
    title: "Crie seu alerta",
    text: "Escolha a rota, as datas e o preço que você quer pagar.",
  },
  {
    title: "A gente monitora",
    text: "Acompanhamos os preços e comparamos com o seu limite.",
  },
  {
    title: "Você é avisado",
    text: "Quando a passagem entrar no seu preço, mandamos o aviso.",
  },
];

/**
 * Tela de cadastro de alerta (`/alertas/novo`): hero com a promessa e o mapa
 * da rota à esquerda, formulário em card à direita, e "Como funciona" abaixo.
 * Ao salvar, volta para `/alertas` com o toast de sucesso.
 */
export default function AlertsCreatePage() {
  const {
    user,
    saving,
    feedback,
    setFeedback,
    initialValues,
    handleSubmit,
    handleValidationError,
  } = useCreateAlert();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Page>
        <HeaderArea>
          <HeaderTemplate />
        </HeaderArea>

        <AlertFormHero mode="create" backTo={ALERTS_LIST_PATH}>
          <AlertForm
            variant="card"
            mode="create"
            initialValues={initialValues}
            saving={saving}
            userEmail={user?.email || ""}
            onSubmit={handleSubmit}
            onValidationError={handleValidationError}
            submitLabel="Criar meu alerta"
            title="Novo alerta de preço"
            footnote="Você pode pausar ou apagar quando quiser."
          />
        </AlertFormHero>

        <HowItWorks>
          <HowTitle>Como funciona</HowTitle>
          <StepsGrid>
            {STEPS.map((step, index) => (
              <StepItem key={step.title}>
                <StepNumber aria-hidden="true">{index + 1}</StepNumber>
                <StepTitle>{step.title}</StepTitle>
                <StepText>{step.text}</StepText>
              </StepItem>
            ))}
          </StepsGrid>
        </HowItWorks>

        <ToastFeedback
          message={feedback?.message ?? ""}
          type={feedback?.type ?? "success"}
          isOpen={Boolean(feedback)}
          onClose={() => setFeedback(null)}
        />
        <AlertsInfoSections />
        <FooterTemplate />
      </Page>
    </ThemeProvider>
  );
}
